import React from "react";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const IconDocuments = ({ width = "24px", height = "24px", fill = "#000" }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" stroke={fill} strokeWidth="2"/>
    <line x1="9" y1="13" x2="15" y2="13" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
    <line x1="9" y1="17" x2="15" y2="17" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default IconDocuments;